<template>
  <div v-if="voteQuestions.length" class="vote-answer">
    <div style="margin-bottom: 12px" class="flex justify-between">
      <span>投票结果</span>
      <span v-if="!isFilter" class="text-theme" @click="onOpenSearch">
        <span>筛选</span>
        <van-icon name="play" />
      </span>
      <span v-else-if="voteQuestions.length===1" class="text-theme-black-450" @click="onOpenSearch">
        <template v-if="answerValues.length > 10">
          <span>{{answerValues.slice(0,10)}}...</span>
        </template>
        <span v-else>{{ answerValues }}</span>
        <van-icon name="play" />
      </span>
      <span v-else class="text-theme-black-450" @click="onOpenSearch">
        <span>以下为筛选后的数据</span>
        <van-icon name="play" />
      </span>
    </div>
    <div v-for="item in voteQuestions" :key="item.q_id">
      <vote-question :question="item" />
    </div>
  </div>
</template>

<script>
import { busGetters, createQuestionFactory } from 'dygc'
import VoteQuestion from '../../vote/VoteQuestion.vue'
import SearchVotePopup from '../../vote/SearchVotePopup.vue'
import { createPopup } from '../../assets/js/factory'

export default {
  name: 'VoteAnswer',
  components: { VoteQuestion },
  computed: {
    ...busGetters(['voteQuestions']),
    isFilter() {
      return this.voteQuestions.some(item => item.issue.hasVoteFilter())
    },
    answerValues() {
      return this.voteQuestions.reduce((res, item) => {
        res += item.issue.getVoteAnswerValueText()
        return res
      }, '')
    }
  },
  methods: {
    onOpenSearch() {
      const list = this.voteQuestions.map((item,index) => {
        const q = createQuestionFactory(item)
        q.setting.enableVoteNum = false
        q.issue.voteAnswer = item.issue.voteAnswer
        q.num = index+1
        return q
      })
      const vm = createPopup(SearchVotePopup, {
        list: list
      })

      vm.$on('confirm', () => {
        this.voteQuestions.forEach((item, index) => {
          item.issue.voteAnswer = list[index].issue.voteAnswer
        })
        vm.$emit('close')
      })
    }
  }
}
</script>
